module.exports = __webpack_public_path__ + "static/media/8OLA1.071a98dd.jpg";